export default {
  methods: {
    checkTone (tonality) {
      const tonalities = [
        'POSITIVE', // Положительная
        'NEUTRAL', // Смешанная
        'NEGATIVE', // Отрицательная
        'COMPANY' //
        // 'UNKNOWN', // Неизвестно. TODO: нет иконки
        // 'NOT_RELATIED_COMPANY' // Не имеет отношения к компании. TODO: нет иконки
      ]

      return tonalities.includes(tonality)
    }
  }
}
